module.exports = __webpack_public_path__ + "img/paypal.5e893ed4.png";